module.exports = __webpack_public_path__ + "static/media/vf_wblouse_core.e6142365.svg";